module.exports = __webpack_public_path__ + "static/media/urgency.5f54df25.svg";